import { AccessMenuItem } from '@mode/collections/feature-manage-access';

import { AppStore } from '~/types/main.types';
import { AnalyticsService } from '@mode/shared/util-segment';

export default class CreateSpaceModalController {
  owner: any;
  space: any;
  name: string;
  private accessSelectorInitialized = false;
  private $close: any;
  private defaultAccessLevel: AccessMenuItem['id'] = 'restricted';

  static $inject = ['$scope', 'RxStoreService', 'AnalyticsService'];

  constructor(
    $scope,
    private rxStoreService: AppStore,
    private analyticsService: AnalyticsService
  ) {
    this.space = $scope.owner.modelFromForm_spaces();
    this.space.default_access_level = this.defaultAccessLevel;
    if ($scope.name) {
      this.space.name = $scope.name;
    }

    if ($scope.existingSpace) {
      this.space.name = $scope.existingSpace.name;
      this.space.description = $scope.existingSpace.description;
    }
  }

  handleAccessSelection($event: Partial<AccessMenuItem>) {
    const menu_selection = $event.id;

    this.space.default_access_level = menu_selection;

    if (this.accessSelectorInitialized) {
      this.analyticsService.run('track', 'Menu Selected', {
        location: 'Create collection access',
        resource: 'collection',
        token: this.space.token,
        action: 'Set default access',
        menu_selection,
      });
    } else {
      // flag selector as initialzed after initial selection
      this.accessSelectorInitialized = true;
    }
  }

  createSpace() {
    this.$close(this.space);
  }
}
